import { LicenseTester, StringUtil } from "@mcleod/core";
import {
    DataSourceMode, DataSourceModeChangeEvent, LookupModelSearchEvent, LookupModelSelectionEvent, ValidationResult
} from "@mcleod/components";
import { allPaymentMethods } from "../DrsPayee";
import { AutogenLayoutDriverSettlementProfile } from "./autogen/AutogenLayoutDriverSettlementProfile";
import { BonusTaxUtils } from "../common/BonusTaxUtils";
import { DuplicateId } from "@mcleod/dispatch/src/DuplicateId";

export class DriverSettlementProfile extends AutogenLayoutDriverSettlementProfile {
    onLoad(): void | Promise<void> {
        this.layoutProfileColor.profileDataSource = this.mainDataSource;
        this.sourceDriverSettlementProfile.addAfterModeChangeListener((event: DataSourceModeChangeEvent) => {
            if (event.newMode !== DataSourceMode.SEARCH) {
                this.setPayRateMethodVisibility();
                this.setBonusTaxMethodVisibility();
                this.setOverrideFrequencyVisibility();
            }
            this.textboxPaymentMethod.items = allPaymentMethods;
            this.textboxPaymentMethod.removeItemsWithValue("5");
            this.textboxPaymentMethod.removeItemsWithValue("U");
            const isContractTransferLicensed = LicenseTester.testPackage("com.tms.client.loadmaster.ifuel");
            if (event.newMode == DataSourceMode.SEARCH && !isContractTransferLicensed) {
                this.textboxPaymentMethod.removeItemsWithValue("T");
            } else if ((event.newMode == DataSourceMode.UPDATE || event.newMode == DataSourceMode.ADD) && !this.activeRow.getBoolean("is_contract_transfer", false)) {
                this.textboxPaymentMethod.removeItemsWithValue("T");
            }
            this.textboxPaymentMethod.displayComponentData(this.activeRow, null, 0);
        });
        this.textboxDepartment.addlValidationCallback = () => this.departmentValidator(this.textboxDepartment.text);
        this.textboxPayeeType.addAfterDropdownSelectionListener(() => {
            if (this.sourceDriverSettlementProfile.mode !== DataSourceMode.SEARCH) {
                this.setPayRateMethodVisibility();
                this.setBonusTaxMethodVisibility();
                this.setOverrideFrequencyVisibility();
            }
        });
        this.textboxBonusCode.addLookupModelSelectionListener((event: LookupModelSelectionEvent) => {
            if (this.sourceDriverSettlementProfile.mode !== DataSourceMode.SEARCH) {
                this.setBonusTaxMethodVisibility();
            }
        });
        this.textboxReasonCode.addBeforeLookupModelSearchListener((event: LookupModelSearchEvent) => {
            event.filter.is_active = "Y";
            event.filter.code_type = "S";
        });
        this.textboxBonusCode.addBeforeLookupModelSearchListener((event: LookupModelSearchEvent) => {
            event.filter.is_active = "Y";
        });
        this.textboxBonusTaxMethod.addlValidationCallback = (value: string): ValidationResult => {
            const result: ValidationResult = {
                component: this.textboxBonusTaxMethod,
                isValid: true
            };
            if (this.textboxBonusTaxMethod.visible && StringUtil.isEmptyString(value)) {
                result.isValid = false;
                result.validationMessage = "Bonus Tax Method is required when a Bonus Code is selected.";
            }
            return result;
        }
        this.mainDataSource.doBeforeDataSourcePost = async () => {
            return BonusTaxUtils.checkBonusTaxRates(this.activeRow);
        };
        DuplicateId.configureIdTextbox(this.textboxId, {
            tableName: "drs_settle_profile",
            screenName: "Driver Settlement Profile",
            navigateToUrl: "lme/settlement/driver-settlement/DriverSettlementProfile?mode=update&key="
        });
    }


    private setPayRateMethodVisibility() {
        this.textboxPayRateMethod.visible = this.textboxPayeeType.selectedItem?.value === "C" || this.textboxPayeeType.selectedItem == null;
        if (!this.textboxPayRateMethod.visible) {
            this.textboxPayRateMethod.clear();
        }
    }

    private setBonusTaxMethodVisibility() {
        const isCompanyOrBoth = this.textboxPayeeType.selectedItem?.value === "C" || this.textboxPayeeType.selectedItem == null;
        const hasBonusCode = !StringUtil.isEmptyString(this.activeRow.get("bonus_code"));
        this.textboxBonusTaxMethod.visible = this.textboxBonusTaxMethod.required = isCompanyOrBoth && hasBonusCode;
        if (!this.textboxBonusTaxMethod.visible) {
            this.textboxBonusTaxMethod.clear();
        }
    }

    private setOverrideFrequencyVisibility() {
        this.textboxOverrideFrequency.visible = this.textboxPayeeType.selectedItem?.value === "C" || this.textboxPayeeType.selectedItem == null;
        if (!this.textboxOverrideFrequency.visible) {
            this.textboxOverrideFrequency.clear();
        }
    }

    private departmentValidator(department: string): ValidationResult {
        const result: ValidationResult = {
            component: this.textboxDepartment,
            isValid: true
        };
        const regex = /^([ 0-9a-zA-Z]{1,3},)*[ 0-9a-zA-Z]{1,3}$/;
        if (!StringUtil.isEmptyString(department) && !regex.test(department)) {
            result.isValid = false;
            result.validationMessage = "Please enter departments (up to 3 characters) delimited by commas.";
        }
        return result;
    }

    textboxPayeeIdsBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter["drs_payee.type_of"] = "in C,O";
    }

    textboxReasonCodeBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_active = "Y";
    }
}
